module.exports = __webpack_public_path__ + "static/media/07.6a93b4eb.jpg";